// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dealer-container[data-v-3196d643]{height:636px}.wrap[data-v-3196d643]{margin:0 auto;width:calc(var(--inner-width)*1px)}.wrap img[data-v-3196d643]{width:inherit;height:500px;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
